function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CropperElement from '@cropper/element';
import { CROPPER_CANVAS, ACTION_NONE, on, EVENT_POINTER_DOWN, EVENT_POINTER_MOVE, EVENT_POINTER_UP, EVENT_WHEEL, off, isNumber, isElement, ATTRIBUTE_ACTION, EVENT_ACTION_START, EVENT_ACTION_MOVE, ACTION_TRANSFORM, EVENT_ACTION, EVENT_ACTION_END, ACTION_SCALE, isString, isPlainObject, isPositiveNumber, getAdjustedSizes, CROPPER_IMAGE, isFunction, ACTION_ROTATE } from '@cropper/utils';
var style = ":host{display:block;min-height:100px;min-width:200px;overflow:hidden;position:relative;touch-action:none;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host([background]){background-color:#fff;background-image:repeating-linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc),repeating-linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc);background-image:repeating-conic-gradient(#ccc 0 25%,#fff 0 50%);background-position:0 0,.5rem .5rem;background-size:1rem 1rem}:host([disabled]){pointer-events:none}:host([disabled]):after{bottom:0;content:\"\";cursor:not-allowed;display:block;left:0;pointer-events:none;position:absolute;right:0;top:0}";

var CropperCanvas = /*#__PURE__*/function (_CropperElement) {
  _inherits(CropperCanvas, _CropperElement);

  var _super = _createSuper(CropperCanvas);

  function CropperCanvas() {
    var _this;

    _classCallCheck(this, CropperCanvas);

    _this = _super.apply(this, arguments);
    _this.$onPointerDown = null;
    _this.$onPointerMove = null;
    _this.$onPointerUp = null;
    _this.$onWheel = null;
    _this.$wheeling = false;
    _this.$pointers = new Map();
    _this.$style = style;
    _this.$action = ACTION_NONE;
    _this.background = false;
    _this.disabled = false;
    _this.scaleStep = 0.1;
    _this.themeColor = '#39f';
    return _this;
  }

  _createClass(CropperCanvas, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(CropperCanvas.prototype), "connectedCallback", this).call(this);

      if (!this.disabled) {
        this.$bind();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (!this.disabled) {
        this.$unbind();
      }

      _get(_getPrototypeOf(CropperCanvas.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "$propertyChangedCallback",
    value: function $propertyChangedCallback(name, oldValue, newValue) {
      if (Object.is(newValue, oldValue)) {
        return;
      }

      _get(_getPrototypeOf(CropperCanvas.prototype), "$propertyChangedCallback", this).call(this, name, oldValue, newValue);

      switch (name) {
        case 'disabled':
          if (newValue) {
            this.$unbind();
          } else {
            this.$bind();
          }

          break;
      }
    }
  }, {
    key: "$bind",
    value: function $bind() {
      if (!this.$onPointerDown) {
        this.$onPointerDown = this.$handlePointerDown.bind(this);
        on(this, EVENT_POINTER_DOWN, this.$onPointerDown);
      }

      if (!this.$onPointerMove) {
        this.$onPointerMove = this.$handlePointerMove.bind(this);
        on(this.ownerDocument, EVENT_POINTER_MOVE, this.$onPointerMove);
      }

      if (!this.$onPointerUp) {
        this.$onPointerUp = this.$handlePointerUp.bind(this);
        on(this.ownerDocument, EVENT_POINTER_UP, this.$onPointerUp);
      }

      if (!this.$onWheel) {
        this.$onWheel = this.$handleWheel.bind(this);
        on(this, EVENT_WHEEL, this.$onWheel, {
          passive: false,
          capture: true
        });
      }
    }
  }, {
    key: "$unbind",
    value: function $unbind() {
      if (this.$onPointerDown) {
        off(this, EVENT_POINTER_DOWN, this.$onPointerDown);
        this.$onPointerDown = null;
      }

      if (this.$onPointerMove) {
        off(this.ownerDocument, EVENT_POINTER_MOVE, this.$onPointerMove);
        this.$onPointerMove = null;
      }

      if (this.$onPointerUp) {
        off(this.ownerDocument, EVENT_POINTER_UP, this.$onPointerUp);
        this.$onPointerUp = null;
      }

      if (this.$onWheel) {
        off(this, EVENT_WHEEL, this.$onWheel, {
          capture: true
        });
        this.$onWheel = null;
      }
    }
  }, {
    key: "$handlePointerDown",
    value: function $handlePointerDown(event) {
      var buttons = event.buttons,
          button = event.button,
          type = event.type;

      if (this.disabled || // Handle pointer or mouse event, and ignore touch event
      (type === 'pointerdown' && event.pointerType === 'mouse' || type === 'mousedown') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var $pointers = this.$pointers;
      var action = '';

      if (event.changedTouches) {
        Array.from(event.changedTouches).forEach(function (_ref) {
          var identifier = _ref.identifier,
              pageX = _ref.pageX,
              pageY = _ref.pageY;
          $pointers.set(identifier, {
            startX: pageX,
            startY: pageY,
            endX: pageX,
            endY: pageY
          });
        });
      } else {
        var _event$pointerId = event.pointerId,
            pointerId = _event$pointerId === void 0 ? 0 : _event$pointerId,
            pageX = event.pageX,
            pageY = event.pageY;
        $pointers.set(pointerId, {
          startX: pageX,
          startY: pageY,
          endX: pageX,
          endY: pageY
        });
      }

      if ($pointers.size > 1) {
        action = ACTION_TRANSFORM;
      } else if (isElement(event.target)) {
        action = event.target.action || event.target.getAttribute(ATTRIBUTE_ACTION) || '';
      }

      if (this.$emit(EVENT_ACTION_START, {
        action: action,
        relatedEvent: event
      }) === false) {
        return;
      } // Prevent page zooming in the browsers for iOS.


      event.preventDefault();
      this.$action = action;
      this.style.willChange = 'transform';
    }
  }, {
    key: "$handlePointerMove",
    value: function $handlePointerMove(event) {
      var $action = this.$action,
          $pointers = this.$pointers;

      if (this.disabled || $action === ACTION_NONE || $pointers.size === 0) {
        return;
      }

      if (this.$emit(EVENT_ACTION_MOVE, {
        action: $action,
        relatedEvent: event
      }) === false) {
        return;
      } // Prevent page scrolling.


      event.preventDefault();

      if (event.changedTouches) {
        Array.from(event.changedTouches).forEach(function (_ref2) {
          var identifier = _ref2.identifier,
              pageX = _ref2.pageX,
              pageY = _ref2.pageY;
          var pointer = $pointers.get(identifier);

          if (pointer) {
            Object.assign(pointer, {
              endX: pageX,
              endY: pageY
            });
          }
        });
      } else {
        var _event$pointerId2 = event.pointerId,
            pointerId = _event$pointerId2 === void 0 ? 0 : _event$pointerId2,
            pageX = event.pageX,
            pageY = event.pageY;
        var pointer = $pointers.get(pointerId);

        if (pointer) {
          Object.assign(pointer, {
            endX: pageX,
            endY: pageY
          });
        }
      }

      var detail = {
        action: $action,
        relatedEvent: event
      };

      if ($action === ACTION_TRANSFORM) {
        var pointers2 = new Map($pointers);
        var maxRotateRate = 0;
        var maxScaleRate = 0;
        var rotate = 0;
        var scale = 0;
        var centerX = event.pageX;
        var centerY = event.pageY;
        $pointers.forEach(function (pointer, pointerId) {
          pointers2.delete(pointerId);
          pointers2.forEach(function (pointer2) {
            var x1 = pointer2.startX - pointer.startX;
            var y1 = pointer2.startY - pointer.startY;
            var x2 = pointer2.endX - pointer.endX;
            var y2 = pointer2.endY - pointer.endY;
            var z1 = 0;
            var z2 = 0;
            var a1 = 0;
            var a2 = 0;

            if (x1 === 0) {
              if (y1 < 0) {
                a1 = Math.PI * 2;
              } else if (y1 > 0) {
                a1 = Math.PI;
              }
            } else if (x1 > 0) {
              a1 = Math.PI / 2 + Math.atan(y1 / x1);
            } else if (x1 < 0) {
              a1 = Math.PI * 1.5 + Math.atan(y1 / x1);
            }

            if (x2 === 0) {
              if (y2 < 0) {
                a2 = Math.PI * 2;
              } else if (y2 > 0) {
                a2 = Math.PI;
              }
            } else if (x2 > 0) {
              a2 = Math.PI / 2 + Math.atan(y2 / x2);
            } else if (x2 < 0) {
              a2 = Math.PI * 1.5 + Math.atan(y2 / x2);
            }

            if (a2 > 0 || a1 > 0) {
              var rotateRate = a2 - a1;
              var absRotateRate = Math.abs(rotateRate);

              if (absRotateRate > maxRotateRate) {
                maxRotateRate = absRotateRate;
                rotate = rotateRate;
                centerX = (pointer.startX + pointer2.startX) / 2;
                centerY = (pointer.startY + pointer2.startY) / 2;
              }
            }

            x1 = Math.abs(x1);
            y1 = Math.abs(y1);
            x2 = Math.abs(x2);
            y2 = Math.abs(y2);

            if (x1 > 0 && y1 > 0) {
              z1 = Math.sqrt(x1 * x1 + y1 * y1);
            } else if (x1 > 0) {
              z1 = x1;
            } else if (y1 > 0) {
              z1 = y1;
            }

            if (x2 > 0 && y2 > 0) {
              z2 = Math.sqrt(x2 * x2 + y2 * y2);
            } else if (x2 > 0) {
              z2 = x2;
            } else if (y2 > 0) {
              z2 = y2;
            }

            if (z1 > 0 && z2 > 0) {
              var scaleRate = (z2 - z1) / z1;
              var absScaleRate = Math.abs(scaleRate);

              if (absScaleRate > maxScaleRate) {
                maxScaleRate = absScaleRate;
                scale = scaleRate;
                centerX = (pointer.startX + pointer2.startX) / 2;
                centerY = (pointer.startY + pointer2.startY) / 2;
              }
            }
          });
        });
        var rotatable = maxRotateRate > 0;
        var scalable = maxScaleRate > 0;

        if (rotatable && scalable) {
          detail.rotate = rotate;
          detail.scale = scale;
          detail.centerX = centerX;
          detail.centerY = centerY;
        } else if (rotatable) {
          detail.action = ACTION_ROTATE;
          detail.rotate = rotate;
          detail.centerX = centerX;
          detail.centerY = centerY;
        } else if (scalable) {
          detail.action = ACTION_SCALE;
          detail.scale = scale;
          detail.centerX = centerX;
          detail.centerY = centerY;
        } else {
          detail.action = ACTION_NONE;
        }
      } else {
        var _Array$from = Array.from($pointers.values()),
            _Array$from2 = _slicedToArray(_Array$from, 1),
            _pointer = _Array$from2[0];

        Object.assign(detail, _pointer);
      } // Override the starting coordinate


      $pointers.forEach(function (pointer) {
        pointer.startX = pointer.endX;
        pointer.startY = pointer.endY;
      });

      if (detail.action !== ACTION_NONE) {
        this.$emit(EVENT_ACTION, detail, {
          cancelable: false
        });
      }
    }
  }, {
    key: "$handlePointerUp",
    value: function $handlePointerUp(event) {
      var $action = this.$action,
          $pointers = this.$pointers;

      if (this.disabled || $action === ACTION_NONE) {
        return;
      }

      if (this.$emit(EVENT_ACTION_END, {
        action: $action,
        relatedEvent: event
      }) === false) {
        return;
      }

      event.preventDefault();

      if (event.changedTouches) {
        Array.from(event.changedTouches).forEach(function (_ref3) {
          var identifier = _ref3.identifier;
          $pointers.delete(identifier);
        });
      } else {
        var _event$pointerId3 = event.pointerId,
            pointerId = _event$pointerId3 === void 0 ? 0 : _event$pointerId3;
        $pointers.delete(pointerId);
      }

      if ($pointers.size === 0) {
        this.style.willChange = '';
        this.$action = ACTION_NONE;
      }
    }
  }, {
    key: "$handleWheel",
    value: function $handleWheel(event) {
      var _this2 = this;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.$wheeling) {
        return;
      }

      this.$wheeling = true; // Debounce by 50ms

      setTimeout(function () {
        _this2.$wheeling = false;
      }, 50);
      var delta = event.deltaY > 0 ? -1 : 1;
      var scale = delta * this.scaleStep;
      this.$emit(EVENT_ACTION, {
        action: ACTION_SCALE,
        scale: scale,
        relatedEvent: event
      }, {
        cancelable: false
      });
    }
    /**
     * Changes the current action to a new one.
     * @param {string} action The new action.
     * @returns {CropperCanvas} Returns `this` for chaining.
     */

  }, {
    key: "$setAction",
    value: function $setAction(action) {
      if (isString(action)) {
        this.$action = action;
      }

      return this;
    }
    /**
     * Generates a real canvas element, with the image draw into if there is one.
     * @param {object} [options] The available options.
     * @param {number} [options.width] The width of the canvas.
     * @param {number} [options.height] The height of the canvas.
     * @param {Function} [options.beforeDraw] The function called before drawing the image onto the canvas.
     * @returns {Promise} Returns a promise that resolves to the generated canvas element.
     */

  }, {
    key: "$toCanvas",
    value: function $toCanvas(options) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (!_this3.isConnected) {
          reject(new Error('The current element is not connected to the DOM.'));
          return;
        }

        var canvas = document.createElement('canvas');
        var width = _this3.offsetWidth;
        var height = _this3.offsetHeight;
        var scale = 1;

        if (isPlainObject(options) && (isPositiveNumber(options.width) || isPositiveNumber(options.height))) {
          var _getAdjustedSizes = getAdjustedSizes({
            aspectRatio: width / height,
            width: options.width,
            height: options.height
          });

          width = _getAdjustedSizes.width;
          height = _getAdjustedSizes.height;
          scale = width / _this3.offsetWidth;
        }

        canvas.width = width;
        canvas.height = height;

        var cropperImage = _this3.querySelector(_this3.$getTagNameOf(CROPPER_IMAGE));

        if (!cropperImage) {
          resolve(canvas);
          return;
        }

        cropperImage.$ready().then(function (image) {
          var context = canvas.getContext('2d');

          if (context) {
            var _cropperImage$$getTra = cropperImage.$getTransform(),
                _cropperImage$$getTra2 = _slicedToArray(_cropperImage$$getTra, 6),
                a = _cropperImage$$getTra2[0],
                b = _cropperImage$$getTra2[1],
                c = _cropperImage$$getTra2[2],
                d = _cropperImage$$getTra2[3],
                e = _cropperImage$$getTra2[4],
                f = _cropperImage$$getTra2[5];

            var newE = e;
            var newF = f;
            var destWidth = image.naturalWidth;
            var destHeight = image.naturalHeight;

            if (scale !== 1) {
              newE *= scale;
              newF *= scale;
              destWidth *= scale;
              destHeight *= scale;
            }

            var centerX = destWidth / 2;
            var centerY = destHeight / 2;
            context.fillStyle = 'transparent';
            context.fillRect(0, 0, width, height);

            if (isPlainObject(options) && isFunction(options.beforeDraw)) {
              options.beforeDraw.call(_this3, context, canvas);
            }

            context.save(); // Move the transform origin to the center of the image.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/transform-origin

            context.translate(centerX, centerY);
            context.transform(a, b, c, d, newE, newF); // Reset the transform origin to the top-left of the image.

            context.translate(-centerX, -centerY);
            context.drawImage(image, 0, 0, destWidth, destHeight);
            context.restore();
          }

          resolve(canvas);
        }).catch(reject);
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(CropperCanvas), "observedAttributes", this).concat(['background', 'disabled', 'scale-step']);
    }
  }]);

  return CropperCanvas;
}(CropperElement);

CropperCanvas.$name = CROPPER_CANVAS;
CropperCanvas.$version = '2.1.0';
export { CropperCanvas as default };